import {
    FaTools,
    FaDraftingCompass,
    FaRulerCombined,
    FaPencilRuler,
    FaHammer,
    FaWrench,
    FaCogs,
    FaHardHat,
    FaBezierCurve,
    FaRegLightbulb,
    FaBuilding,
    FaCity,
    FaWarehouse,
    FaCube
} from 'react-icons/fa';

const BackgroundEffect = () => {
    // Architectural tools and iconic elements
    const elements = [
        { Icon: FaTools, top: '10%', left: '5%', delay: '0s', size: '30px' },
        { Icon: FaDraftingCompass, top: '25%', right: '15%', delay: '-5s', size: '40px' },
        { Icon: FaRulerCombined, bottom: '20%', left: '10%', delay: '-8s', size: '35px' },
        { Icon: FaPencilRuler, top: '50%', right: '5%', delay: '-12s', size: '25px' },
        { Icon: FaHammer, bottom: '15%', right: '8%', delay: '-3s', size: '30px' },
        { Icon: FaWrench, bottom: '40%', left: '20%', delay: '-10s', size: '28px' },
        { Icon: FaCogs, top: '15%', left: '40%', delay: '-15s', size: '45px' },
        { Icon: FaHardHat, top: '60%', left: '50%', delay: '-2s', size: '32px' },
        { Icon: FaBezierCurve, bottom: '10%', right: '30%', delay: '-7s', size: '38px' },
        { Icon: FaRegLightbulb, top: '5%', left: '20%', delay: '-4s', size: '25px' },
        { Icon: FaBuilding, top: '35%', left: '30%', delay: '-1s', size: '42px' },
        { Icon: FaCity, top: '70%', right: '40%', delay: '-11s', size: '50px' },
        { Icon: FaWarehouse, bottom: '5%', left: '45%', delay: '-13s', size: '35px' },
        { Icon: FaCube, top: '45%', left: '15%', delay: '-18s', size: '28px' },
        { Icon: FaDraftingCompass, bottom: '50%', right: '20%', delay: '-9s', size: '35px' },
        { Icon: FaTools, top: '80%', left: '60%', delay: '-6s', size: '30px' }
    ];

    return (
        <div className="bg-container">
            {/* Soft Floating Shadows */}
            <div className="bg-blob" style={{ top: '10%', left: '20%' }}></div>
            <div className="bg-blob" style={{ bottom: '15%', right: '10%', animationDelay: '-5s' }}></div>
            <div className="bg-blob" style={{ top: '50%', left: '60%', width: '300px', height: '300px', animationDelay: '-10s' }}></div>

            {/* Iconic Architectural Elements */}
            {elements.map((el, i) => (
                <div
                    key={i}
                    className="background-icon"
                    style={{
                        top: el.top,
                        left: el.left,
                        right: el.right,
                        bottom: el.bottom,
                        animationDelay: el.delay,
                        fontSize: el.size
                    }}
                >
                    <el.Icon />
                </div>
            ))}
        </div>
    );
};






export default BackgroundEffect;
